<form class="login-form" (submit)="onSubmit($event)">
	<dx-form
		[formData]="formData"
		[disabled]="loading"
		[showColonAfterLabel]="true"
		[showRequiredMark]="false"
	>
		<dxi-item
			caption="Email cím"
			dataField="email"
			editorType="dxTextBox"
			[editorOptions]="{
				placeholder: 'Email cím',
				stylingMode: 'filled',
				mode: 'email',
				value: defaultAuthData?.data?.email
			}"
		>
			<dxi-validation-rule
				type="required"
				message="Az email cím kötelező"
			></dxi-validation-rule>
			<dxi-validation-rule
				type="email"
				message="Az email cím érvénytelen"
			></dxi-validation-rule>
			<dxo-label [visible]="false"></dxo-label>
		</dxi-item>

		<dxi-item
			caption="Jelszó"
			dataField="password"
			editorType="dxTextBox"
			[editorOptions]="passwordEditorOptions"
		>
			<dxi-validation-rule
				type="required"
				message="A jelszó megadása kötelező"
			></dxi-validation-rule>
			<dxo-label [visible]="false"></dxo-label>
		</dxi-item>

		<dxi-item
			dataField="rememberMe"
			editorType="dxCheckBox"
			[editorOptions]="{
				text: 'Emlékezzen rám',
				elementAttr: { class: 'form-text' }
			}"
		>
			<dxo-label [visible]="false"></dxo-label>
		</dxi-item>

		<dxi-item itemType="button">
			<dxo-button-options
				width="100%"
				type="default"
				cssClass="btn-sign-in"
				[useSubmitBehavior]="true"
				[template]="'signInTemplate'"
			>
			</dxo-button-options>
		</dxi-item>

		<ng-container *dxTemplate="let item of 'signInTemplate'">
			<span class="dx-button-text">
				<ng-container *ngIf="loading; else notLoading">
					<dx-load-indicator
						width="24px"
						height="24px"
						[visible]="true"
					></dx-load-indicator>
				</ng-container>
				<ng-template #notLoading>Bejelentkezés</ng-template>
			</span>
		</ng-container>
	</dx-form>

	<div class="reset-link">
		<a [routerLink]="resetLink">Elfelejtett jelszó?</a>
	</div>

	<!-- <dx-button
		class="btn-create-account"
		text="Create an account"
		[stylingMode]="btnStylingMode"
		width="100%"
		(onClick)="onCreateAccountClick()">
	</dx-button> -->

	<!-- <app-login-oauth></app-login-oauth> -->
</form>
